<template>
  <v-container fluid>
    <v-toolbar flat class="main-header main-header__transparent mb-6">
      <v-toolbar-title class="main-header__title">
        <h1>Settings</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-row>
      <v-col
        lg="3"
        md="4"
        sm="6"
        cols="12"
        v-for="(item, index) in items"
        :key="index"
      >
        <v-card class="pa-2 settings-card bordered shadow-less">
          <router-link :to="item.link" class="d-flex flex-no-wrap dark">
            <v-avatar class="ma-3 settings-card__icon" size="70" tile>
              <v-icon>{{ item.icon }}</v-icon>
            </v-avatar>
            <v-card-title class="headline"
              ><strong>{{ $t(item.title) }}</strong></v-card-title
            >
          </router-link>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          icon: "mdi-google-nearby",
          title: "global",
          link: "/settings/global",
        },
        // {
        //   icon: "mdi-account-group",
        //   title: "Users",
        //   link: "/settings/users"
        // },
        {
          icon: "mdi-nfc-variant",
          title: "countries",
          link: "/countries",
        },
        {
          icon: "mdi-lock",
          title: "roles",
          link: "/settings/roles",
        },
      ],
    };
  },
};
</script>
